import { useCallback, useEffect, useState } from 'react';
import { IncidentsService } from '../../../services/incidentsService';

export function useFinalCustomerInput(finalCustomerId) {
  const [countServices, setCountServices] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getCountServices = useCallback(async () => {
    if (!finalCustomerId) return null;
    setIsLoading(true);
    try {
      const countData = await IncidentsService.getCountServices({finalCustomerId});
      setCountServices(countData);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [finalCustomerId]);

  useEffect(() => {
    getCountServices();
  }, [getCountServices, finalCustomerId]);

  return {
    isLoading,
    countServices,
  };
}
